module.exports = __webpack_public_path__ + "components/rewards/skiset/static/icon-63c195742e3f18562ca26cd7e87cbf09.svg";